import { APICore } from "../helpers/api/apiCore";

export type UserRole =
  | "Super Admin"
  | "Superior Admin"
  | "Admin"
  | "Moderator"
  | "User"
  | "Cluster User";

const VALID_ROLES: UserRole[] = [
  "Super Admin",
  "Superior Admin",
  "Admin",
  "Moderator",
  "User",
  "Cluster User",
];

/**
 * Returns the current logged-in user's role from the session cookie.
 * Falls back to "User" if the role cannot be determined or is unrecognised.
 */
export function useUserRole(): UserRole {
  const api  = new APICore();
  const user = api.getLoggedInUser();
  const role = user?.role;

  if (!role || !VALID_ROLES.includes(role as UserRole)) {
    if (role) console.warn(`[useUserRole] Unrecognised role: "${role}" — defaulting to "User"`);
    return "User";
  }

  return role as UserRole;
}

/**
 * Returns the full logged-in user object from the session cookie.
 */
export function useLoggedInUser() {
  const api = new APICore();
  return api.getLoggedInUser();
}
